import { render, staticRenderFns } from "./Usuarios.vue?vue&type=template&id=b3601cf4&scoped=true"
import script from "./Usuarios.vue?vue&type=script&lang=js"
export * from "./Usuarios.vue?vue&type=script&lang=js"
import style0 from "./Usuarios.vue?vue&type=style&index=0&id=b3601cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3601cf4",
  null
  
)

export default component.exports